import React from 'react';
import { Card } from '../ui/Card';
import { Activity } from '../../types';
import { Ticket, Server, ShoppingCart, ShieldAlert } from 'lucide-react';
interface ActivityFeedProps {
  activities: Activity[];
}
export function ActivityFeed({
  activities
}: ActivityFeedProps) {
  const getIcon = (type: Activity['type']) => {
    switch (type) {
      case 'ticket':
        return <Ticket className="h-4 w-4 text-blue-500" data-id="element-150" />;
      case 'system':
        return <Server className="h-4 w-4 text-purple-500" data-id="element-151" />;
      case 'order':
        return <ShoppingCart className="h-4 w-4 text-emerald-500" data-id="element-152" />;
      case 'security':
        return <ShieldAlert className="h-4 w-4 text-red-500" data-id="element-153" />;
      default:
        return <Ticket className="h-4 w-4 text-slate-500" data-id="element-154" />;
    }
  };
  return <Card title="Letzte Aktivitäten" className="h-full" data-id="element-155">
      <div className="flow-root" data-id="element-156">
        <ul className="-mb-8" data-id="element-157">
          {activities.map((activity, activityIdx) => <li key={activity.id} data-id="element-158">
              <div className="relative pb-8" data-id="element-159">
                {activityIdx !== activities.length - 1 ? <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-slate-200" aria-hidden="true" data-id="element-160" /> : null}
                <div className="relative flex space-x-3" data-id="element-161">
                  <div className={`h-8 w-8 rounded-full bg-slate-50 border border-slate-200 flex items-center justify-center ring-8 ring-white`} data-id="element-162">
                    {getIcon(activity.type)}
                  </div>
                  <div className="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5" data-id="element-163">
                    <div data-id="element-164">
                      <p className="text-sm text-slate-900" data-id="element-165">
                        {activity.message}
                      </p>
                    </div>
                    <div className="whitespace-nowrap text-right text-xs text-slate-500" data-id="element-166">
                      {activity.timestamp}
                    </div>
                  </div>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </Card>;
}